import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M20.4683 14.9588C20.4683 14.7238 20.4253 12.6308 18.9353 11.4818C18.3473 11.0288 17.3133 10.5758 15.7333 10.9918C15.3023 11.1058 14.8633 11.2288 14.4263 11.3548C14.1353 9.7168 12.7083 8.4668 10.9883 8.4668C9.23028 8.4668 7.78528 9.7738 7.53928 11.4638C7.52228 11.4638 7.50528 11.4588 7.48828 11.4588C5.55828 11.4588 3.98828 13.0288 3.98828 14.9588H1.98828V15.9588C1.98828 19.0258 6.11828 20.3388 7.98828 20.7748V21.9588H15.9883V20.8118C17.8533 20.3648 21.9883 19.0258 21.9883 15.9588V14.9588H20.4683ZM16.2433 12.9258C17.2033 12.6708 17.5873 12.9688 17.7143 13.0668C18.2633 13.4908 18.4683 14.4528 18.4683 14.9598H10.9883C10.9883 14.8218 10.9633 14.6908 10.9473 14.5558C12.1723 14.1398 14.3223 13.4328 16.2433 12.9258ZM9.48828 11.9668C9.48828 11.1398 10.1613 10.4668 10.9883 10.4668C11.8073 10.4668 12.4733 11.1278 12.4863 11.9438C11.5543 12.2388 10.7313 12.5148 10.1503 12.7138C9.96228 12.4908 9.75328 12.2868 9.51528 12.1168C9.50928 12.0658 9.48828 12.0198 9.48828 11.9668ZM7.48828 13.4588C8.31528 13.4588 8.98828 14.1318 8.98828 14.9588H5.98828C5.98828 14.1318 6.66128 13.4588 7.48828 13.4588ZM14.8163 19.0148L13.9883 19.1608V19.9588H9.98828V19.1128L9.15328 18.9718C7.84228 18.7508 5.44528 18.0308 4.44528 16.9578H19.5363C18.5383 18.0428 16.1323 18.7838 14.8163 19.0148Z" }), jsx("path", { fill: "currentColor", d: "M11.0293 2.94559L10.9883 5.94531L12.9881 5.97264L13.0291 2.97292L11.0293 2.94559Z" }), jsx("path", { fill: "currentColor", d: "M17.4082 4.69528L15.2578 6.78711L16.6524 8.22071L18.8028 6.12888L17.4082 4.69528Z" }), jsx("path", { fill: "currentColor", d: "M6.66034 4.6857L5.22656 6.08008L7.31813 8.23074L8.75191 6.83636L6.66034 4.6857Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconMeal1 = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconMeal1.displayName = "IconMeal1";

export { IconMeal1 };
